import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
  height: 100vh
  background-color: rgb(233,228,240);
  background-image: ${props => `url(${props.imgBg})`};
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#e9e4f0",endColorstr="#d4d4d4",GradientType=1);
  background-size: cover;
  background-position: center center;
`;